import React, { useState, useEffect, useCallback } from 'react';
import ReactGA from 'react-ga4';
import './App.css';
import Header from './Components/Header';
import Footer from './Components/Footer';
import About from './Components/About';
import Contact from './Components/Contact';
import Testimonials from './Components/Testimonials';
import sounds from "./shared/sounds/sounds";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Inicializa o Google Analytics
ReactGA.initialize('G-BH7XNTEJ1R');

function App() {
  const [resumeData, setResumeData] = useState({});
  const [soundPlayed, setSoundPlayed] = useState(false);

  useEffect(() => {
    // Envia pageview
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });

    // Carrega os dados
    fetch('/resumeData.json')
      .then(response => response.json())
      .then(data => setResumeData(data))
      .catch(err => {
        sounds.accept.play();
        console.error('Erro ao carregar dados:', err);
      });
  }, []);

  const playSound = useCallback(() => {
    if (soundPlayed) return;

    const playedPromise = sounds.accept.play();
    if (playedPromise) {
      playedPromise
        .then(() => setSoundPlayed(true))
        .catch((e) => {
          setSoundPlayed(false);
          console.log(e);
          if (e.name === 'NotAllowedError' || e.name === 'NotSupportedError') {
            console.log(e.name);
          }
        });
    }
  }, [soundPlayed]);

  return (
    <div className="App" onWheel={playSound}>
      <ToastContainer position="bottom-center" />
      <Header data={resumeData.main} />
      <About data={resumeData.main} />
      <Testimonials data={resumeData.testimonials} />
      <Contact data={resumeData.main} />
      <Footer data={resumeData.main} />
    </div>
  );
}

export default App;
